import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoint } from './endpoints';
import { ExtraInfoCodeValues } from 'app/components/access-panel/shared/types';

export const editApi = {
  getExtraInfo: () => {
    return new RemoteAdminData(endpoint.extraInfo)
      .resource<ApiResponse<ExtraInfoCodeValues[]>>()
      .single();
  },
  getPersonOptions: async () => {
    const response = await new RemoteAdminData(endpoint.personExcluded)
      .resource<ApiResponse<any>>()
      .single();
    return response.data;
  }
};
